import React from "react"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { INTEGRATIONS_CONFIG } from "../../../config/integrations.config"
import { EraUploadHelper } from "../../../helpers/eraUpload.helper"
import type { IEraUploadFileReviewState } from "../../../types/integrations.types"

export const EraUploadReviewX12PanelComponent: React.FunctionComponent<
    IEraUploadReviewX12PanelComponentProps
> = props => {
    const formattedFileSize = EraUploadHelper.formatFileSize(
        props.file.file.size,
    )

    const content = (
        <>
            <PrimaryText typography="h5" weight="semibold">
                X12 835 remittance file
            </PrimaryText>

            <PrimaryText className="mt-[12px]" weight="medium">
                {props.file.file.name}
            </PrimaryText>

            <PrimaryText
                className="mt-[16px]"
                color={NIRVANA_COLORS.brand.grey7}
            >
                {INTEGRATIONS_CONFIG.eraUpload.requiredX12SegmentsLabel} segments
                verified. The full file will upload to secure storage for
                processing.
            </PrimaryText>

            <PrimaryText className="mt-[12px]" typography="subtitleSemibold">
                File size: {formattedFileSize}
            </PrimaryText>
        </>
    )

    if (props.embedded) {
        return <div className={props.className}>{content}</div>
    }

    return (
        <div
            className={`
                mx-[24px] rounded-[8px] border border-solid border-brand-warmLight2
                bg-brand-white px-[24px] py-[32px] max-w-[720px]
                ${props.className ?? ""}
            `}
        >
            {content}
        </div>
    )
}

interface IEraUploadReviewX12PanelComponentProps {
    className?: string
    embedded?: boolean
    file: IEraUploadFileReviewState
}
